import React from "react";
import PageLayout from "../../component/PageLayout";
import IconAdvantageStatement from "../../component/SvgIcons/IconAdvantageStatement";
import IconChecked from "../../component/SvgIcons/IconChecked";
import ChallengesList, { FeaturesList } from "./ChallengesList";
import "./style.css";

export default function TallyPrimeReleasePage() {
  return (
    <div className="home-main relasepage">      
      <PageLayout>
        <div className="box-default relasepagesection-main">
          <div className="container">
            <div className="sales-management d-flex align-items-center justify-content-between flex-column flex-md-row">
              <div className="titletwo">
                <h2>
                  <span>Sales</span> and <span>Stock</span> Visibility
                </h2>
                <h3>Distributors Management System</h3>
              </div>
              <div className="visibility-pic">
                <img
                  src="../images/tally-prime-release/tally-prime-release.svg"
                  alt="Sales and Stock Visibility"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>

        <section className="visibility-channel mt100">
          <div className="container">
            <div className="box-default distribution-main">
            <div className="titletwo text-center">
              {/* <h2>
                <span>Sales and Stock</span> Visibility Channel (SSV)
              </h2> */}
              <div className="business-description">
              <p>
                It is a crucial part of every sales-and-distribution business,
                where every business requires to manage & synchronise their
                channel functions. It becomes important to take 360-degree
                visibility on different channels of their channel tiers, so that
                they are aware about their achievements annually on an average,
                on their channel sales easily.
              </p>
              <p>
                A clear vision aids them to take business decisions for
                inventory as well as finance. The channels include their
                branches, franchises or outlets.
              </p>
              </div>
            </div>
            <div className="distribution-channel flex gap50 flex-column">
            <div className="distribution-left text-center">
              <h3>Scenario You Are In</h3>
              <img
                src="../images/tally-prime-release/scenario-you-are-in.svg"
                alt="Scenario You Are In"
                className="img-fluid"
              />
            </div>

            <div className="distribution-right text-center">
              <img
                src="../images/tally-prime-release/scenario-versus.png"
                alt="vs"
                className="img-fluid"
              />
            </div>

            <div className="distribution-right text-center">
              <h3>Scenario where you will be</h3>
              <img
                src="../images/tally-prime-release/scenario-where-you-will-be.svg"
                alt="Scenario where you will be"
                className="img-fluid"
              />
            </div>

            </div>
          </div>
          </div>
        </section>


        <section className="TallyPrimeRelease-main mt100">
          <div className="container">
        <div className="titletwo text-center">
        <h2>Challenges <span>Faced</span></h2>
        <div className="ourpointlist notroted d-flex flex-wrap mt-24">
          {ChallengesList.map((challenge, index) => (
            <div
              key={index}
              className="challengepoints box-default flex items-center flex-col gap-4 p-3 rounded-3xl transition"
            >
              <div className="challengesicons flex items-center justify-center">
              {challenge.icon}
              </div>
              <p className="text-sm font-medium mb-0">{challenge.title}</p>
            </div>
          ))}
        </div>

      </div>
      </div>
    </section>

        <section className="implementationadvantage pt100">
        <div className="implementationadvantagebg">
          <div className="container">
            <div className="advantage-list">
              <div className="titletwo">
                <h2>
                  Advantage Statement : <span>Adoption of Tally based DMS</span>
                </h2>
              </div>             
              <ul className="d-flex flex-wrap ">
            {FeaturesList.map((item, index) => (
              <li key={index}>
              <IconChecked/> <span>{item}</span>
              </li>
                ))}
          </ul>
            </div>
          </div>
          <IconAdvantageStatement/>
          </div>

          <div className="container">
            <div className="mmplementation-main d-flex justify-content-between flex-md-row flex-column mb100">
              <div className="expertise">
                <div className="titletwo">
                  <h2>
                    Implementation / <span>Rollout Model</span>
                  </h2>
                </div>
                <p>
                  Our expertise lies not just in the product, but in the way the
                  rollouts are done on PAN India basis. We are tied up with an
                  extensive network of Tally Partners who would physically visit
                  your Distributor/Dealer and train him on how to use the
                  solution. Due to this expertise we can achieve speeds of even
                  50-60 rollouts in a month.
                </p>
              </div>

              <div className="expertise">
                <div className="titletwo">
                  <h2>
                    Support / <span>Helpdesk Model</span>
                  </h2>
                </div>
                <p>
                  A DMS is not complete upon installation. It requires hand
                  holding to cater to the day-to-day queries of the
                  Distributor/Dealer on how to use the system efficiently. We
                  provide helpdesk resources who become the single point of
                  contact for all the issues for your Distributor/Dealer network
                  related to Tally
                </p>
              </div>
            </div>
          </div>
        </section>
      </PageLayout>
    </div>
  );
}
